export default __webpack_public_path__ + "static/media/timeIcon.1f91d62d.svg";